import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const cierreComparison = [{
  sit: '"Contame de vos"',
  sin: 'Improvisás',
  con: 'Respuesta de 90 segundos preparada'
}, {
  sit: 'Te ofrecen menos de lo esperado',
  sin: 'Aceptás sin negociar',
  con: 'Script de contraoferta listo'
}, {
  sit: 'No sabés cuánto pedir',
  sin: 'Número al azar',
  con: 'Calculadora del mercado argentino'
}, {
  sit: 'No tenés preguntas para hacer',
  sin: '"Me quedó todo claro"',
  con: '15 preguntas que te hacen ver Senior'
}, {
  sit: 'Te rechazan',
  sin: 'Desaparecés',
  con: 'Técnica que convierte el rechazo en puerta abierta'
}];
const costComparison = [{
  sin: 'CV sin palabras clave',
  costo: 'ATS lo descarta antes de que lo lea un humano'
}, {
  sin: 'Sin sistema de logros',
  costo: 'Uno más entre 200 candidatos iguales'
}, {
  sin: 'Sin negociación',
  costo: 'Aceptás el primer número sin saber cuánto valés'
}, {
  sin: 'Sin plan de postulación',
  costo: 'Semanas buscando sin resultados ni datos'
}];
export function ComparisonTables() {
  return <section className="py-20 px-4" data-id="element-35">
      <div className="max-w-4xl mx-auto space-y-24" data-id="element-36">
        {/* El Cierre Comparison */}
        <div data-id="element-37">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center flex items-center justify-center gap-3" data-id="element-38">
            🕊️ ¿QUÉ AGREGA "EL CIERRE"?
          </h3>

          <div className="bg-[#0a1628] rounded-2xl border border-slate-700 overflow-hidden" data-id="element-39">
            <div className="overflow-x-auto hide-scrollbar" data-id="element-40">
              <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-41">
                <thead data-id="element-42">
                  <tr className="bg-[#112240] border-b border-slate-700" data-id="element-43">
                    <th className="py-4 px-6 text-slate-300 font-semibold w-1/3" data-id="element-44">
                      Situación
                    </th>
                    <th className="py-4 px-6 text-red-400 font-semibold w-1/3 flex items-center gap-2" data-id="element-45">
                      <X className="w-4 h-4" data-id="element-46" /> Sin El Cierre
                    </th>
                    <th className="py-4 px-6 text-green-400 font-semibold w-1/3" data-id="element-47">
                      <div className="flex items-center gap-2" data-id="element-48">
                        <Check className="w-4 h-4" data-id="element-49" /> Con El Cierre
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-50">
                  {cierreComparison.map((row, i) => <tr key={i} className="border-b border-slate-800/50 hover:bg-[#112240]/30 transition-colors" data-id="element-51">
                      <td className="py-4 px-6 font-medium text-white" data-id="element-52">
                        {row.sit}
                      </td>
                      <td className="py-4 px-6 text-slate-400" data-id="element-53">{row.sin}</td>
                      <td className="py-4 px-6 text-[#d4a843] font-medium bg-[#d4a843]/5" data-id="element-54">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <div className="bg-gradient-to-r from-[#112240] to-[#0a1628] rounded-3xl p-8 md:p-12 border border-[#d4a843]/30 text-center relative overflow-hidden" data-id="element-55">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#d4a843] to-transparent opacity-50" data-id="element-56" />
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-57">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h3>
          <p className="text-lg text-slate-300 mb-4 max-w-2xl mx-auto" data-id="element-58">
            Abrís los tomos. Los usás. Si en 7 días no es lo que esperabas:
            devolución del 100% sin formularios.
          </p>
          <p className="text-sm font-bold text-[#d4a843] uppercase tracking-wider" data-id="element-59">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>

        {/* Cost Comparison */}
        <div data-id="element-60">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center flex items-center justify-center gap-3" data-id="element-61">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h3>

          <div className="bg-[#0a1628] rounded-2xl border border-red-900/30 overflow-hidden" data-id="element-62">
            <div className="overflow-x-auto hide-scrollbar" data-id="element-63">
              <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-64">
                <thead data-id="element-65">
                  <tr className="bg-red-950/20 border-b border-red-900/30" data-id="element-66">
                    <th className="py-4 px-6 text-slate-300 font-semibold w-1/2" data-id="element-67">
                      Sin MegaPack
                    </th>
                    <th className="py-4 px-6 text-red-400 font-semibold w-1/2" data-id="element-68">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-69">
                  {costComparison.map((row, i) => <tr key={i} className="border-b border-slate-800/50 hover:bg-red-950/10 transition-colors" data-id="element-70">
                      <td className="py-4 px-6 font-medium text-white" data-id="element-71">
                        {row.sin}
                      </td>
                      <td className="py-4 px-6 text-slate-400" data-id="element-72">{row.costo}</td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>;
}